import React, { useMemo } from 'react';

import { useOrderViewActionTypes } from './use-order-view-action-types';
import OtherActionMenu from '../../components/grid-header/other-action-menu';
import { emptyArray } from 'ui-components/default-props/empty';

/**
 * @param {{
 *   containerClassName?: string;
 * }} props
 * @returns {React.ReactElement}
 */
export const MenuItemsContainer = ({ containerClassName = '' }) => {
  const orderViewActionTypes = useOrderViewActionTypes();
  const otherActions = useMemo(() => {
    if (orderViewActionTypes.length === 0) {
      return emptyArray;
    }
    return orderViewActionTypes.filter((type) => !type.hideFromCurrentPlan);
  }, [orderViewActionTypes]);

  return <OtherActionMenu containerClassName={containerClassName} otherActions={otherActions} />;
};
